import Button from "@app/components/move2Library/Button/Button"
import { Modal } from "@tecreation/funnel-components"

export const MyParadiseDeleteModal = ({ onClose, onDelete, isAddress }) => {
	return (
		<Modal>
			<Modal.Closer onClick={onClose} />
			<Modal.Header>{isAddress ? "Addresse löschen?" : "Account löschen?"}</Modal.Header>
			<Modal.Body>{isAddress ? "Sicher das du deine Addresse löschen möchtest?" : "Sicher das du deinen Account löschen möchtest?"}</Modal.Body>
			<Modal.Footer>
				<div className="flex flex-justify-between">
					<Button style="danger" onClick={onDelete}>
						Löschen
					</Button>
					<Button style="primary" onClick={onClose}>
						Abbrechen
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
